import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledFloatingQuantityPickerContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  position: 'absolute',
  zIndex: 2,
  maxWidth: '88%',
  width: '100%',
  bottom: 0,
  left: 0,
  transform: 'translate(7%, -25%)',
  '&.isDiscounted': {
    maxWidth: '95%',
    transform: 'translate(2.5%, -12%)',
    [theme.breakpoints.down('sm')]: {
      transform: 'translate(2.5%, -8%)'
    },
    '&.slabPriceInfoText': {
      transform: 'translate(2.5%, -28%)',
      [theme.breakpoints.down('sm')]: {
        transform: 'translate(2.5%, -20%)'
      }
    }
  },
  [theme.breakpoints.down('sm')]: {
    transform: 'translate(7%, -20%)'
  }
}));
